<template>
  <div class="content">
    <div class="info">
      <div class="name">{{ info.productName }}</div>
      <div class="number">保单号：{{ info.policyNo }}</div>
    </div>
    <div class="tip"><div>请仔细填写并核对以下信息</div></div>
    <div class="form-item">
      <div class="title">出险人信息</div>
      <div class="user-name">
        <span>出险人姓名</span>
        <input type="text" readonly v-model="info.insuranceName" />
      </div>
      <div class="type">
        <span>出险类型</span>
        <div class="type-list">
          <span
            @click="select(1, index)"
            v-for="(item, index) in typeList"
            :key="index"
            :class="{ active: index == typeId }"
            >{{ item }}</span
          >
        </div>
      </div>
      <div class="description">
        <span>出险经过描述</span>
        <textarea
          name=""
          id=""
          cols="30"
          rows="8"
          placeholder="请详细描述患病情况、事故经过、诊疗过程等"
          v-model="description"
        ></textarea>
      </div>
    </div>
    <div class="form-item">
      <div class="title">联系人</div>
      <div class="type concat-type">
        <span>您是保单的</span>
        <div class="type-list">
          <span
            @click="select(2, index)"
            v-for="(item, index) in contactList"
            :key="index"
            :class="{ active: index == contactId }"
            >{{ item }}</span
          >
        </div>
      </div>
      <div class="input-name">
        <span>姓名</span>
        <input
          type="text"
          placeholder="请输入姓名"
          :readonly="contactId == 0"
          v-model="contactName"
        />
      </div>
      <div class="input-phone">
        <span>手机号码</span>
        <input
          type="text"
          placeholder="请输入手机号码"
          :readonly="contactId == 0"
          v-model="phone"
        />
      </div>
    </div>
    <div class="form-item">
      <div class="title">
        理赔提示<span class="small-tip">（请保管好以下资料）</span>
      </div>
      <div class="apply-tip">
        <div>
          <img
            src="../../static/images/applyInfo/confirm-icon.png"
            alt=""
          />正式收据，门诊/住院费用清单，社保结算单
        </div>
        <div>
          <img
            src="../../static/images/applyInfo/confirm-icon.png"
            alt=""
          />相关检查及检验报告
        </div>
        <div>
          <img
            src="../../static/images/applyInfo/confirm-icon.png"
            alt=""
          />意外事故证明（公安机关等机构出具的资料）等
        </div>
      </div>
    </div>
    <div class="link-item" @click="toList">
      <span>历史理赔记录</span>
      <van-icon name="arrow" />
    </div>
    <div class="btn-box">
      <van-button class="btn" round block type="info" @click="submit">提交信息</van-button>
    </div>
  </div>
</template>

<script>
import { loading } from "@/api/mixins";
export default {
  mixins: [loading],
  data() {
    return {
      info: {},
      policyNo: "", //保单号
      plat: "", //平台
      typeId: -1,
      typeList: ["医疗", "重疾", "残疾", "身故", "家财损失", "其他"], //出险类型
      contactId: 0,
      contactList: ["投保人", "其他"],
      description: "",
      contactName: "",
      phone: "",
    };
  },
  created() {
    this.policyNo = this.$route.query.policyNo;
    this.plat = this.$route.query.plat;
    this.getInfo();
  },
    mounted() {
    this.$weixin.hideMenu();
  },
  methods: {
    toList() {
      //理赔记录
      this.$router.push({
        name: "applyInfo.myClaims",
        query: {
          id: 2,
        },
      });
    },
    select(type, id) {
      //选择类型
      type == 1 ? (this.typeId = id) : (this.contactId = id);
      if (type == 2) {
        if (id == 1) {
          this.contactName = "";
          this.phone = "";
        } else {
          this.contactName = this.info.policyerName;
          this.phone = this.info.policyerMobile;
        }
      }
    },
    getInfo() {
      //获取保单信息
      this.loading = true;
      this.$http({
        type: "PUT",
        url: `/api/compensation/${this.plat}/compensationPolicyInfo?policyNo=${this.policyNo}`
      })
        .then((res) => {
          this.info = res.data;
          this.contactName = this.info.policyerName;
          this.phone = this.info.policyerMobile;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
        });
    },
    submit() {
      if (this.typeId < 0) {
        this.$notice.msg("请选择出险类型");
        return;
      }
      if (!this.description) {
        this.$notice.msg("请填写出险经过描述");
        return;
      }
      if (!this.contactName) {
        this.$notice.msg("请填写联系人姓名");
        return;
      }
      if (!this.$regulars.isPhone(this.phone) && !this.phone.includes("*")) {
        this.$notice.msg("请输入正确的手机号码");
        return;
      }
      //提交申请
      this.loading = true;
      this.$http({
        type: "PUT",
        url: "/api/compensation/saveCompensation",
        data: {
          policyId: this.info.policyId,
          productId: this.info.productId,
          accidentPerson: this.info.insuranceName,
          accidentType: this.typeId,
          mobile: this.contactId ? this.phone : "",
          contactName: this.contactName,
          accidentDescribe: this.description,
          plat: this.plat,
        },
      })
        .then((res) => {
          this.loading = false;
          this.$notice.msg("提交成功");
          this.$router.go(-1);
        })
        .catch((error) => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  width: 100%;
  background-color: #f5f7fa;
}
.info {
  background: linear-gradient(180deg, #f4f7ff 0%, rgba(240, 245, 255, 0) 100%);
  opacity: 1;
  padding: 30px;
  .name {
    width:690px;
    font-size: 34px;
    font-weight: 500;
    line-height: 34px;
    color: #3c464f;
  }
  .number {
    font-size: 28px;
    font-weight: 400;
    line-height: 34px;
    color: #666666;
    margin-top: 12px;
  }
}
.tip {
  background-color: #fff;
  padding: 20px 30px 0;
  margin-top: 20px;
  div {
    width:690px;
    height: 50px;
    line-height: 50px;
    background: #fff9f2;
    opacity: 1;
    border-radius: 4px;
    font-size: 24px;
    font-weight: 400;
    color: #ff860f;
    padding-left: 20px;
  }
}
.form-item {
  background-color: #fff;
  margin-bottom: 20px;
  > div {
    display: flex;
    padding: 0 30px;
    > span {
      &:first-child {
        color: #555555;
        font-size: 30px;
        font-weight: 400;
        flex: 0 0 185px;
        margin-right: 35px;
      }
    }
  }
  .user-name {
    border-bottom: 1px solid #eee;
    span:last-child {
      font-size: 30px;
      color: #333;
    }
  }
  .type {
    padding: 20px 30px 8px;
    border-bottom: 1px solid #eee;
    .type-list {
      width:470px;
      display: flex;
      flex-wrap: wrap;
      span {
        width: 146px;
        height: 60px;
        line-height: 60px;
        text-align: center;
        background-color: #f7f7f7;
        font-size: 30px;
        opacity: 1;
        border-radius: 4px;
        margin: 0 15px 15px 0;
        &:nth-child(3n) {
          margin-right: 0;
        }
      }
      .active {
        background: #eaf3ff;
        color: #167aff;
      }
    }
  }
  .concat-type {
    align-items: center;
    padding: 20px 30px;
    .type-list {
      span {
        margin-bottom: 0;
      }
    }
  }
  .description {
    padding: 30px 30px 0;
    textarea {
      width:470px;
      border: none;
      outline: none;
      font-size: 30px;
      color: #a8adb7;
      resize: none;
    }
  }
  .title {
    height: 100px;
    line-height: 100px;
    font-size: 34px;
    font-weight: bold;
    color: #333333;
    opacity: 1;
    border-bottom: 1px solid #ececec;
    .small-tip {
      font-size: 24px;
      font-weight: 400;
      line-height: 33px;
      color: #515c6f;
      opacity: 1;
      flex: auto;
      align-self: center;
    }
  }
  .input-name,
  .input-phone,
  .user-name {
    height: 100px;
    align-items: center;
    input {
      height: 60px;
      flex: auto;
      color: #a8adb7;
      font-size: 30px;
    }
  }
  .user-name {
    input {
      color: #000;
    }
  }
  .apply-tip {
    flex-direction: column;
    padding: 26px 30px 27px;
    font-size: 30px;
    color: #555;
    > div {
      margin-bottom: 15px;
    }
    img {
      width: 32px;
      height: 22px;
      margin-right: 10px;
    }
  }
}
.link-item {
  display: flex;
  align-items: center;
  padding: 0 30px;
  justify-content: space-between;
  height: 100px;
  margin: 20px 0;
  font-size: 30px;
  color: #555;
  background-color: #fff;
}
.btn-box {
  padding: 15px 30px;
  background-color: #fff;
  .btn {
    width:690px;
  }
}
</style>